import React, {useState} from 'react';
import SimmsDatePicker from "../../components/datepicker/SimmsDatePicker";import dayjs from "dayjs";
import {cn} from "../../shadCn/lib/utils";
import {toKSTISOString, toKSTISOStringEnd} from "../../components/commonmethod/CommonMethod";

function DashBoardSalDateSearch({month, setMonth}) {

    const [searchDate, setSearchDate] = useState(month);
    const handleSearchChange = (e) => {
        setMonth((prevChildren) => ({
            ...prevChildren,
            ...e
        }));
    };
    const handleDateChange = (target, value) => {
        setSearchDate((prev) => ({
            ...prev,
            [target] : value
        }))

        handleSearchChange({ [target]: value != null
                ? target === "startDate"
                    ? toKSTISOString(value)
                    : toKSTISOStringEnd(value)
                : value, // value가 존재할 경우 그대로 사용
        });
    };
    return (
        <div className="flex h-[40px] w-full items-center">
            <SimmsDatePicker
                onChange={(v)=>handleDateChange("startDate", v)}
                data={searchDate.startDate}
                constraint={{lessThan : searchDate.endDate && dayjs(searchDate.endDate)}} auth />
            <span className={cn("mx-2 text-[16px] text-[#64748b]")}>~</span>
            <SimmsDatePicker
                onChange={(v)=>handleDateChange("endDate", v)}
                data={searchDate.endDate}
                constraint={{largerThan : searchDate.startDate && dayjs(searchDate.startDate)}} auth />
        </div>
    );
}

export default DashBoardSalDateSearch;